/** @format */

import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';

import { CategorySeoUrlToken } from '@category/data-access';
import { HomrDataService } from '@shared/homr/data-access';
import { Injectable } from '@angular/core';
import { Logger } from '@shared/data-access/services';
import { SeoService } from '@seo/data-access';
import { of } from 'rxjs';

@Injectable()
export class CategoryResolveGuard {
	constructor(
		private log: Logger,
		private router: Router,
		private homrService: HomrDataService,
		private seoService: SeoService
	) {}

	public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.seoService.getSEOData$(route.params['seoToken'], 1).pipe(
			tap((category: CategorySeoUrlToken) => {
				if (typeof category !== 'undefined' && Object.keys(category).length) {
					// Set the 410 status code
					// this.httpService.setStatusCode(410);
					this.homrService.setPageName(route.params['seoToken']);

					if (category && category.categories.length) {
						if (category.categories[0].pageType && category.categories[0].seoUrl) {
							// Will cause a redirect if family page or static page is requested
							// from the category app  ex: /c/baseball-gloves which is family page
							const pageType = category.categories[0].pageType;
							const seoUrl = category.categories[0].seoUrl;
							if (pageType === 'f' || pageType === 's') {
								window.location.replace(`/${pageType}/${seoUrl}`);
							}
						}
						// intialize SEO
						this.seoService.initializePageSEO(
							category,
							state.url.split('?')[0],
							'category'
						);
					}
				} else {
					// Navigate to 404 page
					this.router.navigateByUrl('/404', { skipLocationChange: false });
				}
			}),
			catchError((error) => {
				// Log the error
				this.log.error(
					`APPLICATION_ERROR:HTTP_ERROR: Error getting page by SEO TOKEN: ${
						route.params['seoToken']
					}. ${this.getErrorToPrint(error)}`
				);

				// Navigate to 404 page
				this.router.navigateByUrl('/404', { skipLocationChange: false });

				// Return an undefined Observable
				return of(null);
			})
		);
	}

	/**
	 * @description
	 * Accepts an error and stringifies the important parts
	 */
	private getErrorToPrint(error: any): string {
		try {
			return JSON.stringify(error, ['status', 'message', 'arguments', 'type', 'name']);
		} catch (error) {
			return '';
		}
	}
}
